import { render, staticRenderFns } from "./rightClick.vue?vue&type=template&id=cc3a416a&scoped=true&"
import script from "./rightClick.vue?vue&type=script&lang=js&"
export * from "./rightClick.vue?vue&type=script&lang=js&"
import style0 from "./rightClick.vue?vue&type=style&index=0&id=cc3a416a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3a416a",
  null
  
)

export default component.exports